import { render, staticRenderFns } from "./advertiser-mobile-navbar.vue?vue&type=template&id=23ed5eb5"
import script from "./advertiser-mobile-navbar.vue?vue&type=script&lang=js"
export * from "./advertiser-mobile-navbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports